<template>
  <div class="card mb-25 border-0 rounded-0 bg-white recent-activity-box">
    <div class="card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-md-20 mb-xxxl-25 d-flex align-itemsh5s-center justify-content-between"
      >
        <h5 class="card-title fw-bold mb-0">Activité récente</h5>
      </div>
      <ul class="list ps-0 mb-0 list-unstyled">
        <li
          class="position-relative fw-medium text-dark-emphasis"
          v-for="item in rows"
          :key="item.id"
        >
          <div
            class="icon position-absolute start-0 rounded-circle text-center"
          >
            <i class="ph-duotone ph-check-circle"></i>
          </div>
          <span class="text-black fw-bold"
            >{{ item.task_type }} #{{ item.task_code }}</span
          ><br />
          {{ item.task }}
          <span class="d-block fs-13 mt-1">{{ getDate(item.created_at) }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { reactive, ref, computed, defineComponent, onMounted } from "vue";
import api from "@/utils/axios";
import moment from "moment";

export default defineComponent({
  props: { userId: { type: String, required: true } },
  setup(props) {
    const rows = ref<any[]>([]);

    const fetchData = async () => {
      try {
        const res = await api.get(
          `/api/auth/client/HistoriesUser/${props.userId}`
        );
        rows.value = res.data;
      } catch (error) {
        console.error(error);
      }
    };

    onMounted(fetchData);

    const getDate = (value: any) =>
      moment.utc(String(value)).format("YYYY-MM-DD HH:mm");

    return {
      rows,
      getDate,
    };
  },
});
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  gap: 5px;
  padding: 10px;
}
button {
  padding: 5px 10px;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
}
button.active {
  background: #007bff;
  color: white;
  font-weight: bold;
}
button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>